import axios from "axios";
import * as ActionTypes from "./actionTypes";
import * as urls from "../common/urls";

export function getNearbyConsultants(addressInput, page, pageSize) {

  const request = axios.get(
    urls.Representatives_GetByLocation,
    { headers: { "Content-Type": "application/json" },
      params: {
        area: 0,
        startLat: addressInput.lat,  
        startLng: addressInput.lng,
        countryIsoCode: addressInput.countryIsoCode,
        page: page ? page : 1,
        pageSize: pageSize ? pageSize : 1, // customer request get 1 consultant only
      }
    }, 
  );

  return { type: ActionTypes.GET_NEARBY_CONSULTANTS, payload: request };
}

// sets consultant data in the redux global state
export function setConsultantData(consultant) {
  return { type: ActionTypes.SET_CONSULTANT_DATA, payload: consultant}
}

//export function setActivePage(page) {
//  return { type: ActionTypes.SET_ACTIVE_PAGE, payload: page };
//}

//export function setPager(page, totalPages) {
//  return {
//    type: ActionTypes.SET_PAGER,
//    payload: { activePage: page, totalPages: totalPages }
//  };
//}
